import { render, staticRenderFns } from "./personalReservation.vue?vue&type=template&id=01d1501d&scoped=true"
import script from "./personalReservation.vue?vue&type=script&lang=js"
export * from "./personalReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1501d",
  null
  
)

export default component.exports